(function() {
    let mapDiv = document.getElementById('map');

    if (mapDiv) {
        async function startApp() {
            // Map and marker settings
            let coordinates = [mapDiv.dataset.latitude, mapDiv.dataset.longitude];
            let initialZoom = mapDiv.dataset.zoom;
            let pinText = `<b>${mapDiv.dataset.pinTitle}</b><br>${mapDiv.dataset.pinText}`;

            // Initialize the map
            let map = L.map('map', {
                attributionControl: true,
                fullscreenControl: true
            }).setView(coordinates, initialZoom);

            // Set the tile provider
            const googleMapsLink = `https://www.google.com/maps?q=${coordinates[0]},${coordinates[1]}`;
            L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
                maxZoom: 19,
                attribution: `<a href="${googleMapsLink}" target="_blank">Vezi pe Google Maps</a>`
            }).addTo(map);

            // Add the marker
            let marker = L.marker(coordinates).addTo(map);
            marker.bindPopup(pinText).openPopup();
        }

        async function injectLeaflet() {
            await Promise.all([
                window.injectJs('/assets/tp/leaflet@1.9.4/leaflet.js'),
                window.injectCss('/assets/tp/leaflet@1.9.4/leaflet.css')
            ]);
        }

        async function injectLeafletFullScreen() {
            await Promise.all([
                window.injectJs('/assets/tp/leaflet-fullscreen/leaflet.fullscreen.min.js'),
                window.injectCss('/assets/tp/leaflet-fullscreen/leaflet.fullscreen.css')
            ]);
        }

        async function initializeMap() {
            await injectLeaflet();
            await injectLeafletFullScreen();
            startApp();
        }

        initializeMap();
    }
})();